import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import dashboardImage from './assets/images/Our_Story.webp'; // Replace with your image
import logo from './assets/images/Logo.avif'; // Replace with your logo

function Dashboard() {
    const [welcomeMessage, setWelcomeMessage] = useState('Welcome to Mahesh Furniture');

    useEffect(() => {
        // You could fetch welcome message or image from API here if needed
    }, []);

    return (
        <div className="container" style={{ marginTop: '80px' }}>
            <div className="text-center mb-4">
                {/* Logo */}
                <img src={logo} alt="Logo" style={{ width: '100px' }} className="mb-3" />
                {/* Title */}
                <h2 className="text-primary">{welcomeMessage}</h2>
            </div>

            <div className="d-flex justify-content-center">
                {/* Dashboard Main Image */}
                <img
                    src={dashboardImage}
                    alt="Dashboard Visual"
                    className="img-fluid rounded shadow"
                    style={{ maxHeight: '400px', objectFit: 'cover' }}
                />
            </div>
        </div>
    );
}

export default Dashboard;
